import React from "react";

const ScrollableAircraftSection = () => {
const sampleData = [
    {
        img: 'https://mhcockpit.com/Media/4%20Aviators/Fleet/Al-Sim.jpg',
        name: 'ALSIM AL250 FNPT II Simulator',
        bio: 'A state-of-the-art flight simulator replicating multiple aircraft types for advanced pilot training. It delivers unmatched realism, helping students master navigation, instrument, and emergency procedures safely.',
    },
    {
        img: 'https://mhcockpit.com/Media/4%20Aviators/Fleet/Beechcraft.jpg',
        name: 'Beechcraft',
        bio: 'Renowned for its stability and durability, the Beechcraft is ideal for multi-engine and advanced flight training. Its reliable performance makes it a trusted choice for developing confident, skilled aviators.',
    },
    {
        img: 'https://mhcockpit.com/Media/4%20Aviators/Fleet/Cessna.jpg',
        name: 'CESSNA 150',
        bio: 'The world’s most popular training aircraft, known for its reliability and ease of control. Perfect for students at every level, it provides a smooth, stable, and confidence-building flight experience.',
    },
    {
        img: 'https://mhcockpit.com/Media/4%20Aviators/Fleet/Piper.jpg',
        name: 'Piper PA-38 Tomahawk',
        bio: 'A light training aircraft designed specifically for flight instruction. With responsive handling and simplicity, it’s perfect for beginners to build strong foundational skills.',
    },
    {
        img: 'https://mhcockpit.com/Media/4%20Aviators/Fleet/Tecnam.jpg',
        name: 'Tecnam P2006T',
        bio: 'A modern twin-engine aircraft offering efficiency and advanced avionics for professional training. Its sleek design and fuel efficiency make it a top choice for multi-engine certification.',
    },
];

  return (
    <section className="w-full py-20">
      <div className="max-w-7xl mx-auto px-4">

        {/* Scrollable Cards */}
        <div className="overflow-x-auto scrollbar-hide py-10">
          <div className="flex gap-8 lg:justify-between px-4">
            {sampleData.map((item, index) => (
              <div
                key={index}
                className={`relative flex-shrink-0 rounded-2xl shadow-xl snap-center
                  ${
                    index % 2 === 0
                      ? "translate-y-5"
                      : "-translate-y-5"
                  } 
                  w-[22%] xl:w-[25%] sm:w-[30%] max-sm:w-full h-[600px]`}
              >
                {/* Background Image */}
                <div
                  className="absolute inset-0 bg-cover"
                  style={{ backgroundImage: `url(${item.img})` }}
                ></div>
                <div className="absolute inset-0 bg-black/60"></div>

                {/* Content */}
                <div className="relative z-10 flex flex-col justify-end h-full p-6 text-left text-white">
                  <h3 className="text-2xl font-semibold mb-3">{item.name}</h3>
                  <p className="text-sm md:text-base text-gray-200 leading-relaxed">
                    {item.bio}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScrollableAircraftSection;






// import React, { useRef } from "react";
// import { motion, useScroll, useTransform } from "framer-motion";

// const ScrollableAircraftSection = () => {
//   const ref = useRef(null);
//   const { scrollYProgress } = useScroll({
//     target: ref,
//     offset: ["start start", "end end"],
//   });

//   // Map vertical scroll (0 → 1) to horizontal translation (-X%)
//   const x = useTransform(scrollYProgress, [0, 1], ["0%", "-80%"]);

//   const sampleData = [
//     {
//       img: "https://mhcockpit.com/Media/4%20Aviators/Fleet/Al-Sim.jpg",
//       name: "ALSIM AL250 FNPT II Simulator",
//       bio: "A state-of-the-art flight simulator replicating multiple aircraft types for advanced pilot training. It delivers unmatched realism, helping students master navigation, instrument, and emergency procedures safely.",
//     },
//     {
//       img: "https://mhcockpit.com/Media/4%20Aviators/Fleet/Beechcraft.jpg",
//       name: "Beechcraft",
//       bio: "Renowned for its stability and durability, the Beechcraft is ideal for multi-engine and advanced flight training. Its reliable performance makes it a trusted choice for developing confident, skilled aviators.",
//     },
//     {
//       img: "https://mhcockpit.com/Media/4%20Aviators/Fleet/Cessna.jpg",
//       name: "CESSNA 150",
//       bio: "The world’s most popular training aircraft, known for its reliability and ease of control. Perfect for students at every level, it provides a smooth, stable, and confidence-building flight experience.",
//     },
//     {
//       img: "https://mhcockpit.com/Media/4%20Aviators/Fleet/Piper.jpg",
//       name: "Piper PA-38 Tomahawk",
//       bio: "A light training aircraft designed specifically for flight instruction. With responsive handling and simplicity, it’s perfect for beginners to build strong foundational skills.",
//     },
//     {
//       img: "https://mhcockpit.com/Media/4%20Aviators/Fleet/Tecnam.jpg",
//       name: "Tecnam P2006T",
//       bio: "A modern twin-engine aircraft offering efficiency and advanced avionics for professional training. Its sleek design and fuel efficiency make it a top choice for multi-engine certification.",
//     },
//   ];

//   return (
//     <section ref={ref} className="relative h-[500vh] bg-gray-50">
//       <div className="sticky top-0 h-screen flex items-center overflow-hidden">
//         <motion.div
//           style={{ x }}
//           className="flex gap-10 px-20"
//         >
//           {sampleData.map((item, index) => (
//             <div
//               key={index}
//               className="relative flex-shrink-0 w-[400px] h-[550px] rounded-2xl overflow-hidden shadow-xl"
//             >
//               {/* Background Image */}
//               <div
//                 className="absolute inset-0 bg-cover bg-center"
//                 style={{ backgroundImage: `url(${item.img})` }}
//               ></div>
//               <div className="absolute inset-0 bg-black/60"></div>

//               {/* Content */}
//               <div className="relative z-10 flex flex-col justify-end h-full p-6 text-left text-white">
//                 <h3 className="text-2xl font-semibold mb-3">{item.name}</h3>
//                 <p className="text-sm md:text-base text-gray-200 leading-relaxed">
//                   {item.bio}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </motion.div>
//       </div>
//     </section>
//   );
// };

// export default ScrollableAircraftSection;





// import React, { useRef } from "react";
// import { motion, useScroll, useTransform } from "framer-motion";

// const ScrollableAircraftSection = () => {
//   const ref = useRef(null);

//   // Detect scroll progress within this section
//   const { scrollYProgress } = useScroll({
//     target: ref,
//     offset: ["start start", "end end"],
//   });

//   // Horizontal movement (scrollYProgress: 0 → 1 maps to 0 → -100%)
//   const x = useTransform(scrollYProgress, [0, 1], ["0%", "-100%"]);

//   const sampleData = [
//     {
//       img: "https://mhcockpit.com/Media/4%20Aviators/Fleet/Al-Sim.jpg",
//       name: "ALSIM AL250 FNPT II Simulator",
//       bio: "A state-of-the-art flight simulator replicating multiple aircraft types for advanced pilot training.",
//     },
//     {
//       img: "https://mhcockpit.com/Media/4%20Aviators/Fleet/Beechcraft.jpg",
//       name: "Beechcraft",
//       bio: "Renowned for its stability and durability, ideal for multi-engine and advanced flight training.",
//     },
//     {
//       img: "https://mhcockpit.com/Media/4%20Aviators/Fleet/Cessna.jpg",
//       name: "CESSNA 150",
//       bio: "The world’s most popular training aircraft, known for its reliability and ease of control.",
//     },
//     {
//       img: "https://mhcockpit.com/Media/4%20Aviators/Fleet/Piper.jpg",
//       name: "Piper PA-38 Tomahawk",
//       bio: "A light training aircraft designed specifically for flight instruction with responsive handling.",
//     },
//     {
//       img: "https://mhcockpit.com/Media/4%20Aviators/Fleet/Tecnam.jpg",
//       name: "Tecnam P2006T",
//       bio: "A modern twin-engine aircraft offering advanced avionics for professional pilot training.",
//     },
//   ];

//   return (
//     <div className="w-full bg-gray-50">
//       {/* Horizontal Scroll Section */}
//       <section ref={ref} className="relative h-[600vh]">
//         {/* Sticky container keeps the section visible while scrolling */}
//         <div className="sticky top-0 h-screen flex items-center overflow-hidden">
//           <motion.div
//             style={{ x }}
//             className="flex gap-12 px-20"
//           >
//             {sampleData.map((item, index) => (
//               <div
//                 key={index}
//                 className={`relative flex-shrink-0 w-[400px] h-[550px] rounded-2xl overflow-hidden shadow-xl transition-transform duration-500
//                 ${
//                   index % 2 === 0
//                     ? "translate-y-10"
//                     : "-translate-y-10"
//                 }`}
//               >
//                 {/* Background Image */}
//                 <div
//                   className="absolute inset-0 bg-cover bg-center"
//                   style={{ backgroundImage: `url(${item.img})` }}
//                 ></div>
//                 <div className="absolute inset-0 bg-black/60"></div>

//                 {/* Content */}
//                 <div className="relative z-10 flex flex-col justify-end h-full p-6 text-white">
//                   <h3 className="text-2xl font-semibold mb-3">{item.name}</h3>
//                   <p className="text-sm md:text-base text-gray-200 leading-relaxed">
//                     {item.bio}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </motion.div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ScrollableAircraftSection;
